import blockIndex from 'actions/block/index';
import pageIndex from 'actions/page/index';
import Layout from 'components/Layout';
import HoverableCard from 'components/Layout/components/HoverableCard/HoverableCard';
import Card from 'components/UI/Card';
import Container from 'components/UI/Container';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextButton from 'components/UI/TextButton';
import { useHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import HomeHeader from './components/HomeHeader/HomeHeader';
import './Home.module.scss';
import Stories from './components/Stories/Stories';
import UpcomingEvents from 'components/UI/UpcomingEvents/UpcomingEvents';
import Vacancies from './components/Vacancies/Vacancies';

export default function Home() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(blockIndex(null));
        dispatch(pageIndex());
    }, []);

    const blocks = useSelector((state) => state.block.entities);
    const history = useHistory();

    return (
        <Layout>
            <HomeHeader />
            <Container background>
                {/* <Hero /> */}
                <div styleName="grid">
                    {blocks.allIds.map((blockId) => {
                        const card = blocks.byId[blockId];
                        return (
                            <Card
                                key={card.id}
                                title={card?.name}
                                description={card?.content}
                                image={card?.image}
                                personImage={card?.person_image}
                                popupContent={card?.popup}
                                popupImage={card?.image_popup}
                                page={card?.page}
                                link={card?.link}
                                buttonText={card?.button_text}
                                buttonBackground={
                                    card?.colors?.button_background
                                }
                                homepage
                                video={card?.video}
                                videoType={card?.video_type}
                                background={card?.colors?.background}
                                buttonColor={card?.colors?.button_text}
                                backgroundOverlay={
                                    card?.colors?.background_overlay
                                }
                                textBackground={card?.colors?.text_background}
                                row={parseInt(card?.position?.row)}
                                column={parseInt(card?.position?.column)}
                                width={parseInt(card?.position?.width)}
                            />
                        );
                    })}
                </div>
                <HoverableCard />
                <div styleName="second-grid">
                    <div styleName="block">
                        <div styleName="top">
                            <h2 styleName="underlined">Komende activiteiten</h2>
                            <TextButton
                                color="primary"
                                onClick={() => history.push('/activiteiten')}
                                textAlign="right"
                            >
                                Alle activiteiten bekijken
                                <FontAwesomeIcon icon={faArrowRight} />
                            </TextButton>
                        </div>
                        <UpcomingEvents />
                    </div>
                    <div styleName="block">
                        <div styleName="top">
                            <h2 styleName="underlined">Laatste verhalen</h2>
                            <TextButton
                                color="primary"
                                onClick={() => history.push('/verhalen')}
                                textAlign="right"
                            >
                                Alle verhalen bekijken
                                <FontAwesomeIcon icon={faArrowRight} />
                            </TextButton>
                        </div>
                        <Stories />
                    </div>
                </div>
            </Container>
            <Container color="blue-gray">
                <div styleName="second-grid">
                    <div styleName="block">
                        <div styleName="top">
                            <h2 styleName="underlined">Nieuwste vacatures</h2>
                            <TextButton
                                color="primary"
                                onClick={() => history.push('/vacatures')}
                                textAlign="right"
                            >
                                Alle vacatures bekijken
                                <FontAwesomeIcon icon={faArrowRight} />
                            </TextButton>
                        </div>
                        <Vacancies />
                    </div>
                </div>
            </Container>
            {/* <Container color="blue-gray">
                <div styleName="second-grid">
                    <div styleName="block">
                        <h2 styleName="underlined">Aangesloten scholen</h2>
                        <PartnersCarousel />
                    </div>
                </div>
            </Container> */}
        </Layout>
    );
}
